import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { postTransactionPublic } from "../api";
import { ErrorResponse } from "./useCreateTransaction";

export const useCreateTransactionPublic = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postTransactionPublic,
    onSuccess({ data }) {
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });
      toast.success("Success Create Transaction");
      if (data?.invoiceId) {
        window.open(
          `https://checkout.xendit.co/web/${data.invoiceId}`,
          "_blank"
        );
      }
    },
    onError: (error: ErrorResponse) => {
      const message =
        error?.response?.data?.message || "Failed to create transaction";
      toast.error(message);
    },
  });

  return { transaction: mutate, isPending };
};
